import httpClient from '../httpClient';


const getSliders =  () => httpClient.get('/MainPage/TopSec/Get?page=1&pageSize=10000').then(
  (data) => data
)
  .catch(()=>{
    //
  })
const setSliders =  (params) => httpClient.post('/MainPage/TopSec/Post', {
  text:params.text,
  title:params.title,
  imgPath:params.imgPath,
  buttonText:params.buttonText,
  buttonLink:params.buttonLink

},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putSliders = (params,id) => httpClient.put(`/MainPage/TopSec/PUT/${id}`, {
  id:id,
  text:params.text,
  title:params.title,
  imgPath:params.imgPath,
  buttonText:params.buttonText,
  buttonLink:params.buttonLink},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const  deleteSliders = (id) => httpClient.delete(`/MainPage/TopSec/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export {
  getSliders,
  setSliders,
  putSliders,
  deleteSliders
  // getUser,
  // createUser
}
